<div class="login-wrapper" fxLayout="row" fxLayoutAlign="center center" [style]="{ height: '100vh', backgroundColor: '#3f51b5' }">
    <mat-card appearance="outlined" class="box" style="min-width: 440px">
        <mat-card-header>
            <mat-card-title>{{ "LOGIN.title" | translate }}</mat-card-title>
        </mat-card-header>
        <form class="login-form" #loginForm="ngForm" (ngSubmit)="onLoginFormSubmit()" [formGroup]="loginFormGroup">
            <mat-card-content>
                <mat-form-field class="full-width pb-10">
                    <input matInput [placeholder]="'LOGIN.username' | translate" name="username" formControlName="username" type="email" />
                    @if (loginFormGroup.controls["username"].hasError("notValid")) {
                        <mat-error>
                            {{ errorMessage }}
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="full-width">
                    <input matInput [type]="hidePassword ? 'password' : 'text'" [placeholder]="'LOGIN.password' | translate" name="password" formControlName="password" />
                    <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        (click)="hidePassword = !hidePassword"
                        [attr.aria-label]="(hidePassword ? 'LOGIN.showPassword' : 'LOGIN.hidePassword') | translate"
                        [attr.aria-pressed]="!hidePassword"
                    >
                        <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
                    </button>
                </mat-form-field>
                @if (!environment.local) {
                    <div style="margin: 10px">
                        <ngx-turnstile #turnstile [siteKey]="siteKey" theme="light" formControlName="turnstileToken"></ngx-turnstile>
                        @if (turnstileFailed) {
                            <i style="color: red">
                                Verification Failed.
                                <button mat-button type="button" style="color: blue; padding: 0px" (click)="retryTurnstile()">Try again</button>
                            </i>
                        }
                    </div>
                }
            </mat-card-content>
            <button mat-raised-button color="primary" class="btn-block" type="submit">
                {{ "LOGIN.loginButton" | translate }}
            </button>
        </form>
    </mat-card>
    <span class="app-version">v{{ appVersion }}</span>
</div>
